
const actions = {
}
export default actions


// WEBPACK FOOTER //
// ./packages/question-assembly/store/actions.js